/**
 * Utility function for merging Tailwind classes
 * Uses clsx and tailwind-merge for optimal class composition
 */

import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
